import { Fragment } from 'react';
import styles from './FlowStepIndicator.module.css';

interface FlowStepIndicatorProps {
	labels: string[];
	currentStep: number;
}

export const FlowStepIndicator = ({ labels, currentStep }: FlowStepIndicatorProps) => (
	<div className={styles.steps}>
		{labels.map((label, index) => {
			const stepNumber = index + 1;
			const isActive = stepNumber === currentStep;
			const isDone = stepNumber < currentStep;
			return (
				<Fragment key={stepNumber}>
					{index > 0 && (
						<div className={`${styles.stepLine} ${isDone ? styles.done : ''}`} />
					)}
					<div className={styles.stepItem}>
						<div
							className={`${styles.stepCircle} ${isActive ? styles.active : ''} ${isDone ? styles.done : ''}`}
						>
							{stepNumber}
						</div>
						<span
							className={`${styles.stepLabel} ${isActive ? styles.active : ''} ${isDone ? styles.done : ''}`}
						>
							{label}
						</span>
					</div>
				</Fragment>
			);
		})}
	</div>
);
